/** The width the diagram was dragged to: pixels as written, anything else a share of the article. */
export const parseScale = (scale: string) => (scale ? (scale.endsWith("px") ? scale : +scale) : undefined);

const getAttrs = (attrs: Record<string, string>) => {
	const titleIsWidth = attrs?.title?.includes("px");
	const title = titleIsWidth ? "" : attrs?.title;
	const src = attrs?.path ?? "";
	const width = titleIsWidth ? attrs?.title : attrs?.width;
	const height = titleIsWidth ? attrs?.width : attrs?.height;
	const float = width && height ? attrs?.float : attrs?.title;
	const scale = parseScale(attrs?.scale);

	return { src, title, width, height, float, scale };
};

export default getAttrs;
